import { CreateOrderRequest } from '@models/order';
import { defaultOrderFields } from '@store/defaultOrderFields';

export const initialState: CreateOrderRequest = {
    projectId: '',
    shopId: '',
    shopName: '',
    orderPath: 'DIRECT',
    orderType: 'IN_SHOP',
    orderLines: [],
    discounts: [],
    totalAmount: 0,
    totalDiscount: 0,
    totalCouponDiscount: 0,
    totalPointDiscount: 0,
    ...defaultOrderFields,
    paymentMethod: 'CREDIT_CARD',
    paymentAmount: 0,
    returnUrl: '',
};
